import * as actions from './assign-later.actions';

const initialState = {
  isAssignLaterModalOpen: false,
  assignLaterData: undefined
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.HIDE_ASSIGN_LATER:
      return {
        ...state,
        isAssignLaterModalOpen: false
      };

    case actions.SHOW_ASSIGN_LATER:
      return {
        ...state,
        isAssignLaterModalOpen: true
      };
    case actions.SUBMIT_ASSIGN_LATER:
      return {
        ...state,
        assignLaterData: action.payload,
        isAssignLaterModalOpen: false
      };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./components/assign-later/store/assign-later.reducer.js